import React from 'react';
export function Footer() {
  return <footer className="py-10 px-4 bg-white text-center text-brand-dark/60 text-xs border-t-2 border-brand-light" data-id="element-76">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-77">
        <p className="leading-relaxed max-w-3xl mx-auto font-medium" data-id="element-78">
          © {new Date().getFullYear()} YOGA PRO™ — Tutti i Diritti Riservati.
          Il contenuto di questa pagina ha scopo esclusivamente educativo e non
          sostituisce il consiglio professionale di un'insegnante di yoga o di
          un medico. Segui sempre le linee guida di sicurezza appropriate e
          consulta un professionista della salute prima di iniziare qualsiasi
          programma di movimento.
        </p>
        <div className="flex flex-wrap justify-center gap-4 font-bold tracking-widest uppercase text-[10px] sm:text-xs" data-id="element-79">
          <a href="#" className="hover:text-brand-green transition-colors" data-id="element-80">
            Termini e Condizioni
          </a>
          <span className="hidden sm:inline text-brand-dark/30" data-id="element-81">·</span>
          <a href="#" className="hover:text-brand-green transition-colors" data-id="element-82">
            Privacy Policy
          </a>
          <span className="hidden sm:inline text-brand-dark/30" data-id="element-83">·</span>
          <a href="#" className="hover:text-brand-green transition-colors" data-id="element-84">
            Contatto
          </a>
        </div>
      </div>
    </footer>;
}